export const formatDate = (date: string | Date): string | undefined =>
  date ? new Date(date).toISOString().split("T")[0] : undefined;
